// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterReviews__wrapper-tQiw","reviews":"FooterReviews__reviews-wMDe","reviewsEmpty":"FooterReviews__reviewsEmpty-XU9y"};